export const ONLINE_TRANSLATION_FIELDS_CONSTS = {
  textToTranslation: 'Текст в трансляцию',
  addToNews: 'Добавить в новость',
  invertTime: 'Инвертировать время'
}
